import React, { useEffect, useRef } from "react";
import style from "./EuleriagymBidimensionalBalanceChart.module.sass";
import { bidimensionalChart } from "../euleriagymBalanceCharts";
import { chartSync } from "../chartSync"; // 👈 aggiunto

function EuleriagymBidimensionalBalanceChart(props) {
  const {
    axisTitles,
    clampedData,
    colors,
    data,
    enableLeft,
    enableRight,
    labels
  } = props;

  const canvasWrapper = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    renderChart();
  }, [clampedData, labels]);

  useEffect(() => {
    updateChartColors();
  }, [enableLeft, enableRight]);

  const getDatasets = (dataset) => {
    return dataset.map((item, index) => ({
      data: item,
      borderColor: colors[index],
      backgroundColor: colors[index],
    }));
  };

  const renderChart = () => {
    if (canvasWrapper.current) {
      let canvas = canvasWrapper.current.querySelector("canvas");
      if (canvas) {
        canvas.remove();
      }

      canvas = document.createElement("canvas");
      canvasWrapper.current.appendChild(canvas);

      const datasets = getDatasets(clampedData);
      const tooltipDatasets = getDatasets(data);

      chartInstance.current = bidimensionalChart(
        canvas,
        datasets,
        labels,
        tooltipDatasets,
        axisTitles
      );

      // === SYNC HOVER START (ottimizzato) ===
      let lastMove = 0;
      canvas.addEventListener("mousemove", (event) => {
        const now = performance.now();
        // throttling: massimo 50 fps circa
        if (now - lastMove < 50) return;
        lastMove = now;

        if (!chartInstance.current || !chartInstance.current.data) return;

        const points = chartInstance.current.getElementsAtEventForMode(
          event,
          "nearest",
          { intersect: true },
          false
        );
        if (points.length > 0) {
          const index = points[0].index;
          chartSync.publish(index);
        }
      });

      canvas.addEventListener("mouseout", () => {
        chartSync.publish(null);
      });
      // === SYNC HOVER END ===

      // === SYNC SUBSCRIBE (ottimizzato e fluido) ===
      if (!chartInstance.current.__syncSubscribed) {
        chartInstance.current.__syncSubscribed = true;

        chartSync.subscribe((hoverIndex) => {
          const chart = chartInstance.current;
          if (!chart) return;

          // evita update ridondanti
          if (chart._lastHoverIndex === hoverIndex) return;
          chart._lastHoverIndex = hoverIndex;

          if (hoverIndex === null) {
            chart.setActiveElements([]);
            chart.tooltip.setActiveElements([], { x: 0, y: 0 });
            requestAnimationFrame(() => chart.update("none"));
            return;
          }

          const meta = chart.getDatasetMeta(0);
          if (!meta || !meta.data[hoverIndex]) return;

          // 🔹 attiva TUTTI i dataset allo stesso indice
          const allElements = chart.data.datasets.map((_, datasetIndex) => ({
            datasetIndex,
            index: hoverIndex
          }));

          chart.setActiveElements(allElements);
          chart.tooltip.setActiveElements(allElements, {
            x: meta.data[hoverIndex].x,
            y: meta.data[hoverIndex].y
          });

          requestAnimationFrame(() => chart.update("none"));
        });
      }
      // === SYNC SUBSCRIBE END ===
    }
  };

  const updateChartColors = () => {
    if (chartInstance.current && enableLeft != null && enableRight != null) {
      chartInstance.current.data.datasets.map((dataset, index) => {
        if (index == 0) {
          dataset.borderColor = enableLeft
            ? colors[index]
            : "rgba(255, 164, 17, 0.2)";
          dataset.backgroundColor = dataset.borderColor;
        } else {
          dataset.borderColor = enableRight
            ? colors[index]
            : "rgba(167, 120, 255, 0.2)";
          dataset.backgroundColor = dataset.borderColor;
        }
      });
      chartInstance.current.update("none");
    }
  };

  return (
    <div className={style.chartWrapper}>
      <div className={style.yUnit}>[cm]</div>
      <div className={style.xUnit}>[cm]</div>
      <div ref={canvasWrapper} className={style.canvasWrapper}></div>
    </div>
  );
}

export default EuleriagymBidimensionalBalanceChart;
